export default {

  // convert returned rows (as JSON) of db data to GEOJSON
  // handles points and polygons and multipolygons geojson objects
  // Option to generate the GEOJSON for the centre points of Polygons as well
  // May be able to replace with https://www.npmjs.com/package/geojson

  jsonToGeoJsonFeatureCollection: function jsonToGeoJsonFeatureCollection (rows, includePolygonCentres) {
    var obj, i, feature;
    var geometry, geometryPolygon;

    obj = {
      type: 'FeatureCollection',
      features: []
    };

    // console.log(JSON.stringify(rows));
    // results from postgrespool are string, while those from sequelize are objects
    // if (rows.length > 0) {
    //     geomString = (typeof rows[0]['geometry'] === 'string');
    // }

    for (i = 0; i < rows.length; i++) {
      var row = rows[i];
      geometry = null;
      geometryPolygon = null;

      // All geojson have points or centre point objects
      if (typeof row.geometry === 'string') {
        geometry = JSON.parse(row.geometry);
      } else {
        geometry = row.geometry;
      }
      // Some geojsons will also have polygon outlines
      if (row.geometry_polygon) {
        if (typeof row.geometry_polygon === 'string') {
          geometryPolygon = JSON.parse(row.geometry_polygon);
        } else {
          geometryPolygon = row.geometry_polygon;
        }
      } else {
        geometryPolygon = null;
      }

      // Main Feature (a point)
      feature = {
        type: 'Feature',
        properties: row.properties,
        geometry: geometry,
      };
      obj.features.push(feature);

      // If there it is a polygon then double up and add a polygon feature as well
      // For a polygon item the polygon Feature will have all the same properties as its centre point Feature added just above
      if (includePolygonCentres && geometryPolygon) {
        feature = {
          type: 'Feature',
          properties: row.properties,
          geometry: geometryPolygon,
        };
        obj.features.push(feature);
      }
    }
    return obj;
  },
  // convert returned rows (as arrays) of db data to GEOJSON
  // only includes specified properties on each feature
  // Assumes the geojson item in the array is being provided as a string
  // If combinedProperty is set then all properties are merged into a single object property
  // TODO: May be able to replace with https://www.npmjs.com/package/geojson or Probably can do more efficiently with map()
  // objectProperties = optional array of properties which should be treated as objects and parsed into JSON from strings
  toGeoJsonFeatureCollection: function toGeoJsonFeatureCollection (rows, propertiesToInclude, geometryKey, combinedProperty, propertiesAsObjects) {
    var obj, i;

    obj = {
      type: 'FeatureCollection',
      features: []
    };

    // results from postgrespool are string, while those from sequelize are objects
    var geomString = (typeof rows[0][geometryKey] === 'string');

    for (i = 0; i < rows.length; i++) {
      var item, feature, geometry, properties;
      item = rows[i];

      if (geomString) {
        geometry = JSON.parse(item[geometryKey]);
      } else {
        geometry = item[geometryKey];
      }
      // build object of properties want to keep - feels a bit clunky this approach
      properties = {};
      for (var j = 0; j < propertiesToInclude.length; j++) {
        // Use hasOwnProperty rather than data[[propertiesToInclude[j]]) since if value were 0 was failing if and skipping it
        if (item.hasOwnProperty(propertiesToInclude[j])) {
          if (!propertiesAsObjects || propertiesAsObjects.indexOf(propertiesToInclude[j]) === -1) {
            // not in propertiesAsObjects list - leave it as whatever it is
            properties[propertiesToInclude[j]] = item[propertiesToInclude[j]];
          } else {
            // treat it as an object
            properties[propertiesToInclude[j]] = JSON.parse(item[propertiesToInclude[j]]);
          }
        }
      }

      if (combinedProperty) {
        // Want it to be {properties: {<combinedProperty>: {prop1: val1, prop2: val2, ...}}
        feature = {
          type: 'Feature',
          properties: {},
          geometry: geometry
        };
        feature.properties[combinedProperty] = properties;
      } else {
        feature = {
          type: 'Feature',
          properties: properties,
          geometry: geometry
        };
      }

      obj.features.push(feature);
    }
    return obj;
  },

  getTwitterUrl: function (twitterHandle) {
    return 'https://www.twitter.com/' + twitterHandle;
  },

  // Test for website URL not any old URL. Can be optional with flag.
  isUrl: function isUrl (str, optional) {
    // Can be blank but if set must be valid URL
    if (optional && !str) return true;
    // eslint-disable-next-line no-useless-escape
    var patt = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
    var res = patt.test(str);
    return (res);
  },

  // Is a Twitter handle like string? Starts with @ and at least a couple of chars. Can be optional with flag.
  // Max 15 (plus @), alphanumeric and _
  isTwitterHandle: function isTwitterHandle (str, optional) {
    if (optional && !str) return true;
    return (str.length > 3 && str.length <= 16 && str.charAt(0) === '@' && this.isAlphaNumeric(str.substring(2)));
  },

  // spaces tabs or similar
  hasWhiteSpace (s) {
    return /\s/g.test(s);
  },

  isAlphaNumeric (s) {
    // \W is equiv of [^0-9a-zA-Z_]
    return /^([a-zA-Z0-9_]+)$/g.test(s);
  },

  isEven (n) {
    return n % 2 === 0;
  },

  isOdd (n) {
    return n % 2 !== 0;
  },

  replaceNonAlphaNumber (str, char) {
    // Replace non-alphanumerics in string with char
    // https://stackoverflow.com/questions/20864893/replace-all-non-alpha-numeric-characters-new-lines-and-multiple-white-space-wi
    return str.replace(/[\W_]+/g, char);
  },

  isEmailProbably (str) {
    // Checks for basic form anystring@anystring.anystring rather than absolute certainty
    // - it does not trim the string - caller should do that if spaces on end are acceptable
    // https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript

    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(str);
  },

  lowerFirstLetter: function (str) {
    return str.substring(0, 1).toLowerCase() + str.substring(1);
  },

  limitLengthOfStringEllipsisInMiddle: function (string, maxLength) {
    if (string.length <= maxLength) return string;
    var outerLength = (maxLength - 3) / 2; // -3 since ... is 3 long
    return string.slice(0, outerLength) + '...' + string.slice(string.length - outerLength);
  },

  limitLengthOfStringSubstitute: function (string, maxLength, subsString) {
    if (string.length <= maxLength) return string;
    return subsString;
  },

  splitArray (input, spacing) {
    // Sequentially split array into N sub-arrays each of length spacing
    // https://stackoverflow.com/questions/11345296/partitioning-in-javascript
    // in: [1,2,3,4,5,6,7,8,9]
    // out: [[1,2,3],[4,5,6],[7,8,9]]
    var output = [];
    for (var i = 0; i < input.length; i += spacing) {
      output[output.length] = input.slice(i, i + spacing);
    }
    return output;
  },

  crossSplitArray (input, spacing) {
    // Split array "across then down" array into N sub-arrays each of length spacing
    // i.e. create 'spacing' columns
    // in: [1,2,3,4,5,6,7,8,9] , 3
    // out: [[1,4,7],[2,5,8],[3,6,9]]
    // in: [1,2] , 3
    // out: [[1],[2],[<empty>]]
    var output = [];
    var segment;
    for (var i = 0; i < input.length; i++) {
      segment = i % spacing;
      if (!output[segment]) { output[segment] = []; }
      output[segment].push(input[i]);
    }

    // top up columns with []
    if (output.length < spacing) {
      for (var k = output.length; k < spacing; k++) {
        output[k] = [];
      }
    }
    return output;
  },

  /**
   * Randomize array element order in-place.
   * Using Durstenfeld shuffle algorithm.
   * Modifies the provided ARRAY since passed by reference
   * https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
   */
  shuffleArray (array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  },

  /**
   * Pick random element
   * @param array
   * @returns {item}
   */
  pickRandom (array) {
    if (!array) return undefined;
    if (array.length === 0) return array[0];
    return array[Math.floor(array.length * Math.random())];
  },

  obscuredEmail (email) {
    if (email) {
      return email.substring(0, 4) + '**' + email.substring(email.length - 5, email.length);
    } else {
      return '';
    }
  },

  /**
   * Return string based on plural or not
   */
  plural (num, singleStr, pluralStr) {
    if (num && num > 1) {
      return pluralStr;
    } else {
      return singleStr;
    }
  },

  /**
   * clampString
   * @param str
   * @param len
   * @returns {string}
   */
  clampString (str, maxlen) {
    return str.length > maxlen ? str.substr(0, maxlen - 3) + '...' : str;
  },

  isPostcode (str) {
    // validate a postcode - it does not trim the string - caller should do that if spaces on end are acceptable
    // call it!
    return checkPostCode(str);

    /* ==================================================================================================
    Source: https://www.braemoor.co.uk/software/postcodes.shtml

    Version:       V5.0
    Date:          8th November 2012
    Specific support added for new BFPO postcodes
    Parameters:    toCheck - postcodeto be checked.
    This function checks the value of the parameter for a valid postcode format. The space between the
    inward part and the outward part is optional, although is inserted if not there as it is part of the
    official postcode.

    If the postcode is found to be in a valid format, the function returns the postcode properly
    formatted (in capitals with the outward code and the inward code separated by a space. If the
    postcode is deemed to be incorrect a value of false is returned.
    -------------------------------------------------------------------------------------------------- */

    function checkPostCode (toCheck) {
      // Permitted letters depend upon their position in the postcode.
      var alpha1 = '[abcdefghijklmnoprstuwyz]'; // Character 1
      var alpha2 = '[abcdefghklmnopqrstuvwxy]'; // Character 2
      var alpha3 = '[abcdefghjkpmnrstuvwxy]'; // Character 3
      var alpha4 = '[abehmnprvwxy]'; // Character 4
      var alpha5 = '[abdefghjlnpqrstuwxyz]'; // Character 5
      var BFPOa5 = '[abdefghjlnpqrst]'; // BFPO alpha5
      var BFPOa6 = '[abdefghjlnpqrstuwzyz]'; // BFPO alpha6

      // Array holds the regular expressions for the valid postcodes
      var pcexp = [];

      // BFPO postcodes
      pcexp.push(new RegExp('^(bf1)(\\s*)([0-6]{1}' + BFPOa5 + '{1}' + BFPOa6 + '{1})$', 'i'));

      // Expression for postcodes: AN NAA, ANN NAA, AAN NAA, and AANN NAA
      pcexp.push(new RegExp('^(' + alpha1 + '{1}' + alpha2 + '?[0-9]{1,2})(\\s*)([0-9]{1}' + alpha5 + '{2})$', 'i'));

      // Expression for postcodes: ANA NAA
      pcexp.push(new RegExp('^(' + alpha1 + '{1}[0-9]{1}' + alpha3 + '{1})(\\s*)([0-9]{1}' + alpha5 + '{2})$', 'i'));

      // Expression for postcodes: AANA  NAA
      pcexp.push(new RegExp('^(' + alpha1 + '{1}' + alpha2 + '{1}' + '?[0-9]{1}' + alpha4 + '{1})(\\s*)([0-9]{1}' + alpha5 + '{2})$', 'i'));

      // Exception for the special postcode GIR 0AA
      pcexp.push(/^(GIR)(\s*)(0AA)$/i);

      // Standard BFPO numbers
      pcexp.push(/^(bfpo)(\s*)([0-9]{1,4})$/i);

      // c/o BFPO numbers
      pcexp.push(/^(bfpo)(\s*)(c\/o\s*[0-9]{1,3})$/i);

      // Overseas Territories
      pcexp.push(/^([A-Z]{4})(\s*)(1ZZ)$/i);

      // Anguilla
      pcexp.push(/^(ai-2640)$/i);

      // Load up the string to check
      var postCode = toCheck;

      // Assume we're not going to find a valid postcode
      var valid = false;

      // Check the string against the types of post codes
      for ( var i = 0; i < pcexp.length; i++) {
        if (pcexp[i].test(postCode)) {
          // The post code is valid - split the post code into component parts
          pcexp[i].exec(postCode);

          // Copy it back into the original string, converting it to uppercase and inserting a space
          // between the inward and outward codes
          postCode = RegExp.$1.toUpperCase() + ' ' + RegExp.$3.toUpperCase();

          // If it is a BFPO c/o type postcode, tidy up the "c/o" part
          postCode = postCode.replace(/C\/O\s*/, 'c/o ');

          // If it is the Anguilla overseas territory postcode, we need to treat it specially
          if (toCheck.toUpperCase() === 'AI-2640') {postCode = 'AI-2640';}

          // Load new postcode back into the form element
          valid = true;

          // Remember that we have found that the code is valid and break from loop
          break;
        }
      }

      // Return with either the reformatted valid postcode or the original invalid postcode
      if (valid) {return postCode;} else return false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/lib/myfunc.js